// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Enum-like object representing the available string formats for month and weekday names
 * used in calendar localization.
 */ export const CalendarFormat = {
    long: "long",
    short: "short",
    narrow: "narrow"
};
// Helper to get weekday names (Sunday = 0)
// The date 2020-01-05 is used as a reference to ensure consistent weekday names across locales.
export const getWeekdayNames = (format, locale)=>{
    const start = Temporal.PlainDate.from({
        year: 2020,
        month: 1,
        day: 5
    });
    return Array.from({
        length: 7
    }, (_, i)=>start.add({
            days: i
        }).toLocaleString(locale, {
            weekday: format
        }));
};
/**
 * Returns the timezone to use when rendering UI (currently returns User/System timezone)
 * Note: We had option of static constant initialized on app start, or dynamic fetch method.
 * They differ in what happens if user changes system timezone while app is running.
 * Static constant has benefit of never having mixed timezone rendering in UI (but user needs to refresh browser)
 * Dynamic fetch method has the opposite pros/cons, and we elected to go with dynamic fetch (better chance of showing correct timezone without refresh)
 */ export const getTimeZone = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
